export const EmbedReportFilterResources = {
  EmbedReportFilter: 'Product Filter',
  EmbedReportFilters: 'Product Filters',
  Type: 'Type',
  Type_Hint: 'Hint: Please select the control type of the filter',
  Type_Placeholder: 'Type a Type',
  CascadeField: 'Cascade field',
  CascadeField_Hint: 'Hint: Please select the Cascade field of the product filter',
  CascadeField_Placeholder: 'Type a Cascade field',
  EmbedReportFilterCascadeFilter: 'Cascade Filter',
  EmbedReportFilterCascadeFilter_Hint: 'Hint: Please select the cascade filters',
  EmbedReportFilterCascadeFilter_Placeholder: 'Select a product cascade filter',
  DefaultValue: 'Default value',
  DefaultValue_Hint: 'Hint: Please select the default/prefined value(s) of the filter',
  DefaultValue_Placeholder: 'Type a Default value',
  DefaultValue_PlaceholderSelect: 'Select the default value',
  Expression: 'DAX Expression',
  Conditions: 'DAX Internal Conditions',
  Expression_Hint: 'Hint: Please select the Expression of the product filter',
  Expression_Placeholder: 'Type a Expression',
  Field: 'Field',
  TableField: 'Table+Field',
  Field_Hint: 'Hint: Please select the Field of the product filter',
  Field_Placeholder: 'Select a Catalog+Table+Field',
  FilterName: 'Filter name',
  FilterName_Hint: 'Hint: Please select the display filter name',
  FilterName_Placeholder: 'Type a Filter name',
  Scope: 'Scope',
  Scope_Hint: 'Hint: Please select the scope of the filter: report, page or internal',
  Scope_Placeholder: 'Select the scope',
  Method: 'Method',
  Method_Hint: 'Hint: Please select the Method of the filter',
  Method_Placeholder: 'Type a Method',
  Order: 'Order',
  Order_Hint: 'Hint: Define the display order',
  Order_Placeholder: 'Type a Order',
  Pages: 'Pages',
  Pages_Hint: 'Hint: Please select the Pages of the filter',
  Pages_Placeholder: 'Please the pages',
  EmbedReport: 'Product',
  EmbedReport_Hint: 'Hint: Please select the product of the filter',
  EmbedReport_Placeholder: 'Select a product',
  Catalog: 'Catalog',
  Catalog_Hint: 'Hint: Please select the Catalog of the filter',
  Catalog_Placeholder: 'Select a Cube/Catalog',
  Table: 'Table',
  Table_Hint: 'Hint: Please select the Table of the filter',
  Table_Placeholder: 'Select a Table',
  Status: 'Status',
  RLS: 'Row-Level Security',
  RLS_Hint: 'Hint: Please check if the underlying dataset table uses row-level security',
  RLS_Placeholder: 'Type a RLS',
  IsNot: 'Is Not',
  IsNot_Hint: 'Hint: Please check if the filter expression should be NOT equal/NOT contains',
  IsNot_Placeholder: 'Check a IsNot',
};

export const EmbedReportPageResources = {
  EmbedReportPage: 'Product Page',
  EmbedReportPages: 'Product Pages',
  Type: 'Type',
  Type_Hint: 'Hint: Please select the Type of the page',
  Type_Placeholder: 'Type a Type',
  DisplayName: 'Display Name',
  DisplayName_Hint: 'Hint: Please select the display name of the page',
  DisplayName_Placeholder: 'Type a Display name',
  NetGross: 'Net/Gross',
  NetGross_Hint: 'Hint: Please select the Net/Gross flag of the page',
  NetGross_Placeholder: 'Type a Net/Gross',
  Order: 'Order',
  Order_Hint: 'Hint: Please select the display order of the page',
  Order_Placeholder: 'Type the page order',
  PageCode: 'Page Code in Power BI',
  PageCode_Hint: 'Hint: Please select the Page code of the page',
  PageCode_Placeholder: 'Type a Page code',
  PageName: 'Page Name in Power BI',
  PageName_Hint: 'Hint: Please select the Page name of the page',
  PageName_Placeholder: 'Type a Page name',
  EmbedReport: 'Product',
  EmbedReport_Hint: 'Hint: Please select the product of the page',
  EmbedReport_Placeholder: 'Select a product',
  EmbedReportPageTwinPage: 'Twin Page',
  EmbedReportPageTwinPage_Hint: 'Hint: Please select the twin page for Net/Gross switch',
  EmbedReportPageTwinPage_Placeholder: 'Select a page',
  Status: 'Status',
};

export const RequestAccessPageResources = {
  Requestor: 'Requestor',
  ApplicationInstance: 'Application Instance',
  Group: 'Group',
  Group_Hint: 'Hint: Please select the Group',
  Group_Placeholder: 'Select a group',
  Comment: 'Comment',
  Comment_Hint: 'Hint: Please enter the Comment',
  Comment_Placeholder: 'Enter the comment',
  SuccessMessage: 'Access request submitted successfully'
}

export const EmbedReportResources = {
  EmbedReport: 'Product',
  EmbedReports: 'Products',
  Type: 'Type',
  Type_Hint: 'Hint: Please select the product type',
  TypePersonalize_Hint:
    'Hint: To get all the advantages of Personalize Power BI remember the option Personalize visuals should be active in the linked product ',
  Type_Placeholder: 'Select a product type',
  Market: 'Market',
  Market_Hint: 'Hint: Please select the Market of the embed product',
  Market_Placeholder: 'Select a market',
  ContactOrSupportEmail: 'Additional Information',
  ContactOrSupportEmail_Hint: 'Hint: Please set the additional info link of the embed product',
  ContactOrSupportEmail_Placeholder: 'Type an additional info link',
  EmbedAreaUrl: 'Url',
  EmbedAreaUrl_Hint: 'Hint: Please type the URL to redirect to',
  EmbedAreaUrl_Placeholder: 'Type a Embed Url',
  EmbedArea: 'Area',
  EmbedArea_Hint: 'Hint: Please select the area of the embed product',
  EmbedArea_Placeholder: 'Type a Embed area',
  EmbedPage: 'Embed page',
  EmbedPage_Hint: 'Hint: Please select the Embed page of the embed product',
  EmbedPage_Placeholder: 'Type a Embed page',
  Groups: 'Groups',
  Groups_Hint: 'Hint: Please select the Groups of the embed product',
  Groups_Placeholder: 'Type a Groups',
  NetGross: 'Net/Gross Filter',
  NetGross_Hint: 'Hint: Please check if Net/Gross filter must be enable',
  NetGross_Placeholder: 'Type a Net/Gross',
  PowerDataSourceId: 'Power BI Dataset ID',
  PowerDataSourceId_Hint: 'Hint: Please select the Power BI datasource identifier',
  PowerDataSourceId_Placeholder: 'Type a Power BI datasource id',
  PowerReportId: 'Power BI Report ID',
  PowerReportId_Hint: 'Hint: Please select a Power BI report',
  PowerReportId_Placeholder: 'Type a Power BI report id',
  PowerRole: 'Power BI Roles',
  PowerRole_Hint: 'Hint: Please select the Power BI Roles to enabled row-level security',
  PowerRole_Placeholder: 'Select the Power BI Roles',
  PowerWorkspaceId: 'Power BI Workspace ID',
  Workspace: 'Workspace',
  Report: 'Report',
  Dataset: 'Dataset',
  PowerWorkspaceId_Hint: 'Hint: Please select a Power BI workspace',
  PowerWorkspaceId_Placeholder: 'Type a Power BI Workspace ID',
  ReportName: 'Product Name',
  ReportName_Hint: 'Hint: Please type a a meaningful and distintive product name',
  ReportName_Placeholder: 'Type a product Name',
  RLS: 'Row-Level Security',
  RLS_Short: 'RLS',
  RLS_Hint: 'Hint: Please check if the underlying dataset uses row-level security',
  RLS_Placeholder: 'Type a RLS',
  Section: 'Section',
  Section_Hint: 'Hint: Please select the section of the embed product',
  Section_Placeholder: 'Select a section',
  Tags: 'Tags',
  Tags_Hint: 'Hint: Please select the Tags to enabled advanced searching',
  Tags_Placeholder: 'Select the tags',
  Environment: 'Environment',
  Environment_Placeholder: 'Select a Environment',
  Environment_Hint: 'Hint: Please select the environment of the embed product',
  Source: 'Principal Source',
  Source_Hint: 'Hint: Please select the Source of the embed product',
  Source_Placeholder: 'Type a Source',
  ViewMode: 'View Mode',
  ViewMode_Hint: 'Hint: Please select the default view mode',
  ViewMode_Placeholder: 'Select a View Mode',
  BgColor: 'Background Color',
  BgColor_Hint: 'Hint: Please select the default background color',
  BgColor_Placeholder: 'Select a background color',
  Embedded: 'Embedded',
  Embedded_Short: 'Embedded',
  Embedded_Hint: 'Hint: Please check if the product must be present embedded',
  Embedded_Placeholder: 'Embedded',
  DefaultFilter: 'Default Filter',
  DefaultFilter_Short: 'DefaultFilter',
  DefaultFilter_Hint: 'Hint: Please check to use powerbi default filter instead',
  DefaultFilter_Placeholder: 'Default Filter',
  CustomGroups: 'Custom Groups',
  CustomGroups_Short: 'Custom Groups',
  CustomGroups_Hint: 'Hint: Please check if the product must be able to override RLS groups',
  CustomGroups_Placeholder: 'Custom Groups',
  Status: 'Status',
  MamApplicationInstance: 'Matrix Access Manager Application Instance',
  MamApplicationInstance_Hint: 'Hint: Please select the Matrix Access Manager Application Instance',
};

export const MarketResources = {
  Market: 'Market/Region',
  Markets: 'Markets/Regions',
  IsoCode: 'ISO Code',
  Comments: 'Comments',
  Comments_Hint: 'Hint: Please select the comments of the market/region',
  Comments_Placeholder: 'Type a Comments',
  Culture: 'ISO Code Culture',
  Culture_Hint: 'Hint: Please type the ISO culture code for the markets or type XX for regions',
  Culture_Placeholder: 'Type a Culture',
  Status: 'Status',
};

export const SectionResources = {
  Section: 'Section',
  Sections: 'Sections',
  Description: 'Description',
  Description_Hint: 'Hint: Please select the description of the market/region',
  Description_Placeholder: 'Type a Description',
  LongName: 'LongName',
  LongName_Hint: 'Hint: Please type the ISO culture code for the markets or type XX for regions',
  LongName_Placeholder: 'Type a LongName',
  Status: 'Status',
};
